import useController from '@common/hooks/useController'

// Native shim — read state from in-process ControllerStore.
// Web variant relies on `ActivityControllerStateProvider` not mounted on RN.
export default function useActivityControllerState(): any {
  const { state } = useController('ActivityController' as any)
  return state as any
}
